import './modals.css';

export const NotificationModal = ({ notificationModal, setNotificationModal }) => {
  if (!notificationModal.show) return null;

  const onClose = () => setNotificationModal({ ...notificationModal, show: false });

  return (
    <div className="notification-modal-overlay" onClick={onClose}>
      <div className="notification-modal" onClick={(e) => e.stopPropagation()}>
        <div className="notification-modal-icon">
          {notificationModal.type === 'success' ? (
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
              <circle cx="32" cy="32" r="30" fill="rgba(34, 197, 94, 0.1)" stroke="#22c55e" strokeWidth="2" />
              <path d="M20 32l8 8 16-16" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          ) : (
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
              <circle cx="32" cy="32" r="30" fill="rgba(239, 68, 68, 0.1)" stroke="#ef4444" strokeWidth="2" />
              <path d="M32 20v16M32 44h.01" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
        <h2 className="notification-modal-title">{notificationModal.title}</h2>
        <p className="notification-modal-message">{notificationModal.message}</p>
        <button className="notification-modal-button" onClick={onClose}>OK</button>
      </div>
    </div>
  );
};
